import { Component } from '@angular/core';

@Component({
  selector: 'fgb-edit-questions-page',
  templateUrl: './edit-questions-page.component.html',
  styleUrls: ['./edit-questions-page.component.scss'],
})
export class EditQuestionsPageComponent {}
